<script setup lang="ts">
import { PhoneInputQC } from '@qicgroupdoha/qic-connect-ds';
import { useMutation } from '@tanstack/vue-query';
import { toTypedSchema } from '@vee-validate/yup';
import { useForm } from 'vee-validate';

import { defaultValidationRule } from '@/shared/constants/validationRules';
import { FlowButton } from '@/shared/ui/FlowButton';

import { useRequestCallbackService } from '../api';
import { getValidationScheme } from '../model/getValidationScheme';

interface RequestCallbackEmits {
  (e: 'callback'): void;
}

const emits = defineEmits<RequestCallbackEmits>();

const sendCallbackApi = useRequestCallbackService();
const { mutateAsync: sendCallback, isPending } = useMutation({
  mutationFn: sendCallbackApi.sendCallback,
});

const scheme = getValidationScheme();
const { defineField, handleSubmit, errors, setErrors } = useForm({
  validationSchema: toTypedSchema(scheme),
});
const [phoneValue, phoneProps] = defineField('phone', defaultValidationRule);

const handleSendCallback = handleSubmit(async (formValues) => {
  await sendCallback({ phone: formValues.phone.replaceAll(/[ +]/g, '') });
  emits('callback');
});
</script>

<template>
  <PhoneInputQC
    v-model="phoneValue"
    data-test="callback-phone"
    v-bind="phoneProps"
    :errors="errors.phone"
    country-lock
    @focus="setErrors({ phone: undefined })"
  />
  <FlowButton
    class="request-callback__submit-button"
    size="medium"
    :loading="isPending"
    @submit="handleSendCallback"
  >
    {{ $t('qic.send') }}
  </FlowButton>
</template>
